//* Japanese. Translated by: Google Translate.
export default {
  selectedCountryAriaLabel: "選択した国",
  noCountrySelected: "国が選択されていません",
  countryListAriaLabel: "国のリスト",
  searchPlaceholder: "検索",
  zeroSearchResults: "結果が見つかりません",
  oneSearchResult: "1 件の結果が見つかりました",
  multipleSearchResults: "${count} 件の結果が見つかりました",
  
  // additional countries (not supported by country-list library)
  ac: "アセンション島",
  xk: "コソボ",
};
